import type { PaginatedResponse } from '@shared/types';
import { z } from 'zod';

export const $EconomicActivity = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
});

export type EconomicActivity = z.infer<typeof $EconomicActivity>;

export type GetEconomicActivitiesResponse = PaginatedResponse<EconomicActivity>;
